import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { ticketOffersByCodeQuery } from 'queries/tickets/queries';
import { QueryVariables, StaleTime } from 'queries/types';

import { useTicketingEventId } from './utils';

export const useTicketOffersByCode = (
  {
    code,
  }: Partial<Pick<QueryVariables<typeof ticketOffersByCodeQuery>, 'code'>>,
  options?: Partial<ReturnType<typeof ticketOffersByCodeQuery>>,
) => {
  const { locale } = useLocale();
  const { eventId, timeslotId } = useTicketingEventId();
  const query = useQuery({
    ...ticketOffersByCodeQuery({
      eventId,
      timeslotId,
      code: code ?? '',
      locale,
    }),
    enabled: !!code,
    staleTime: StaleTime.ONE_HOUR,
    ...options,
  });

  return {
    ticketOffers: query.data ?? [],
    isLoading: query.isLoading,
    status: query.status,
    refetch: query.refetch,
  };
};
